var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  because of\n  "),_c('help-center-link',{attrs:{"linkKey":"payment/failed"}},[_vm._v("payment failed")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }